/**
 * Project Service - إدارة المشاريع في Supabase
 * يتعامل مع جدول projects
 */

import { supabase } from '../external/supabase';

/**
 * إنشاء مشروع جديد
 * @param {string} status - القيمة الافتراضية: 'uploading'
 */
export async function createProject({ 
  userId, 
  title, 
  videoPath, 
  videoUrl, 
  videoSize 
}) {
  try {
    const { data, error } = await supabase
      .from('projects')
      .insert([
        {
          user_id: userId,
          title,
          status: 'uploading',
          video_path: videoPath,
          video_url: videoUrl,
          video_size: videoSize,
          created_at: new Date().toISOString(),
        }
      ])
      .select()
      .single();

    if (error) {
      console.error('❌ Error creating project:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('❌ Failed to create project:', error);
    throw error;
  }
}

/**
 * تحديث المشروع
 */
export async function updateProject(projectId, updates) {
  try {
    const { data, error } = await supabase
      .from('projects')
      .update(updates)
      .eq('id', projectId)
      .select()
      .single();

    if (error) {
      console.error('❌ Error updating project:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('❌ Failed to update project:', error);
    throw error;
  }
}

/**
 * تحديث حالة المشروع
 * @param {string} status - 'draft' | 'uploading' | 'uploaded' | 'processing' | 'transcribing' | 'editing' | 'rendering' | 'completed' | 'failed' | 'deleted'
 */
export async function updateProjectStatus(projectId, status) {
  try {
    const updates = { status };

    // إضافة timestamps حسب الحالة (فقط إذا كانت الأعمدة موجودة)
    if (status === 'completed') {
      updates.completed_at = new Date().toISOString();
    }
    // ملاحظة: عمود error_at غير موجود في الجدول، لذا لا نضيفه

    const { data, error } = await supabase
      .from('projects')
      .update(updates)
      .eq('id', projectId)
      .select()
      .single();

    if (error) {
      console.error('❌ Error updating project status:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('❌ Failed to update project status:', error);
    throw error;
  }
}

/**
 * الحصول على مشروع بواسطة ID
 */
export async function getProject(projectId) {
  try {
    const { data, error } = await supabase
      .from('projects')
      .select('*')
      .eq('id', projectId)
      .single();

    if (error) {
      console.error('❌ Error fetching project:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('❌ Failed to fetch project:', error);
    throw error;
  }
}

/**
 * الحصول على جميع مشاريع المستخدم
 */
export async function getUserProjects(userId) {
  try {
    const { data, error } = await supabase
      .from('projects')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('❌ Error fetching user projects:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('❌ Failed to fetch user projects:', error);
    throw error;
  }
}

/**
 * حذف مشروع
 */
export async function deleteProject(projectId) {
  try {
    const { error } = await supabase
      .from('projects')
      .delete()
      .eq('id', projectId);

    if (error) {
      console.error('❌ Error deleting project:', error);
      throw error;
    }

    return true;
  } catch (error) {
    console.error('❌ Failed to delete project:', error);
    throw error;
  }
}